import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getVehiclePath } from './Utils/vehicleUrls';

function RecentlyViewed({ cars }) {
  const location = useLocation();

  if (!Array.isArray(cars) || cars.length === 0) return null;

  return (
    <div style={{ marginTop: '3rem' }}>
      <h3 style={{ marginBottom: '1rem', color: '#004D40' }}>Recently Viewed</h3>
      <div style={{
        display: 'flex',
        gap: '1rem',
        overflowX: 'auto',
        paddingBottom: '1rem'
      }}>
        {cars.map(car => {
          const targetPath = getVehiclePath(car);
          return (
          <Link key={car.id} to={targetPath} onClick={(event) => {
            if (location.pathname === targetPath) event.preventDefault();
          }} style={{
            minWidth: '200px',
            maxWidth: '200px',
            flex: '0 0 auto',
            border: '1px solid #ccc',
            borderRadius: '8px',
            backgroundColor: '#fff',
            padding: '0.5rem',
            cursor: 'pointer',
            color: 'inherit',
            textDecoration: 'none',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            transition: 'transform 0.2s'
          }}
            onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.02)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
          >
            <img src={car.images || "https://meshumimages.blob.core.windows.net/websiteimages/defaultCar.jpg"}
              alt="Car"
              style={{ width: '100%', borderRadius: '6px', marginBottom: '0.5rem' }}
            />
            <h4 style={{ margin: "0 0 0.25rem 0", fontSize: "1rem" }}>{car.year} {car.make} {car.model}</h4>
            <p style={{ fontWeight: 'bold', color: '#004D40', margin: 0 }}>${car.price.toLocaleString()}</p>
          </Link>
          );
        })}
      </div>
    </div>
  );
}

export default RecentlyViewed;
